import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm } from 'react-material-ui-form-validator';

import {
	withStyles,
	withWidth,
	Grid,
	Typography,
	Button,
	TextField,
	Divider,
	RootRef,
	Tooltip
} from '@material-ui/core';

import Constants from "../utils/Constants";
import FormHelper from "../utils/FormHelper";
import ResponsiveDialog from "./ResponsiveDialog";
import LabeledCheckbox from "./LabeledCheckbox";

const styles = theme => ({
	dlgPaper: {
		minWidth: 325
	},

	button: {
		"@media (hover: none)": {
			"&:hover": {
				backgroundColor: theme.palette.primary.main
			}
		}
	},

	buttonGrid: {
		marginTop: theme.spacing(2)
	},

	noteFieldRoot: {
		fontSize: "1rem"
	},

	noteField: {
		width: "100%",
		color: theme.palette.primary.darkGrey,
		borderRadius: theme.spacing(2.5),
		backgroundColor: theme.palette.primary.grey,

		"& input": {
			padding: "9px 12px"
		}
	},

	saveBtn: {
		whiteSpace: "nowrap"
	},

	noThxBtnItem: {
		paddingRight: theme.spacing(1)
	},

	questionItem: {
		paddingBottom: theme.spacing(4)
	},

	subtitle: {
		paddingBottom: theme.spacing(4)
	},

	dlgTitle: {
		paddingBottom: 0
	}
});

class CareAlertDialog extends Component {
	constructor(props, context) {
		super(props, context);

		this.dialog = React.createRef();
		this.state = this.initialState;

		this.careStatus = this.careStatus.bind(this);
		this.saveClicked = this.saveClicked.bind(this);
	}

	get initialState() {
		return {
			careStatus: null
		};
	}

	componentDidMount() {
		this.setState(this.props.rating);
	}

	careStatus(status) {
		this.setState({careStatus: status});
	}

	saveClicked() {
		let {careStatusHandler, activityId, closeHandler} = this.props;
		let {careStatus} = this.state;
		if(careStatus === Constants.ACTIVITY.CARE_STATUSES.REVOKED.ID) {
			careStatusHandler(activityId, careStatus, '');
		}
		this.nextStep();
		closeHandler();
	}

	nextStep() {
		let {nextStepHandler} = this.props;
		if (nextStepHandler) {
			nextStepHandler();
		}
	}

	render() {
		let {careStatus} = this.state,
			{classes, open, width, closeHandler, showSubtitle} = this.props,
			smaller = width.includes("sm") || width.includes("xs"),
			content = (
				<RootRef rootRef={this.dialog}>
					<React.Fragment>
						{showSubtitle ? <Typography className={classes.subtitle}>{Constants.ACTIVITY.ACTION_BUTTONS.getRate().tooltip}</Typography> : null}
						<Grid container direction="column" justify="space-between">
							<Grid item className={classes.questionItem}>
								<Typography className={classes.question}>Do you want to revoke this alert from Care as well?</Typography>
								<Grid container justify="space-around" className={classes.buttonGrid}>
									<Grid item>
										<Button
											onClick={() => this.careStatus(Constants.ACTIVITY.CARE_STATUSES.REVOKED.ID)}
											className={classes.button}
											variant={careStatus === Constants.ACTIVITY.CARE_STATUSES.REVOKED.ID ? "contained" : "outlined"}
											color={careStatus === Constants.ACTIVITY.CARE_STATUSES.REVOKED.ID ? "primary" : "default"}>
											Yes
										</Button>
									</Grid>
									<Grid item>
										<Button
											onClick={() => this.careStatus(Constants.ACTIVITY.CARE_STATUSES.SHARED.ID)}
											className={classes.button}
											variant={careStatus === Constants.ACTIVITY.CARE_STATUSES.SHARED.ID ? "contained" : "outlined"}
											color={careStatus === Constants.ACTIVITY.CARE_STATUSES.SHARED.ID ? "primary" : "default"}>
											No
										</Button>
									</Grid>
								</Grid>
							</Grid>
							<Grid item>
							<Grid
									container
									justify="space-between"
									alignItems="center"
									className={classes.buttonGrid}>
									<Grid item>
										{!smaller ?
											<Button onClick={closeHandler}>
												Cancel
											</Button> : null
										}
									</Grid>
									<Grid item>
										<Button
											color="primary"
											variant="contained"
											className={classes.saveBtn}
											disabled={careStatus === null}
											onClick={this.saveClicked}>
											Remove Alert
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</React.Fragment>
				</RootRef>
			);

		return (
			<ResponsiveDialog
				open={open}
				maxWidth="xs"
				title="This alert is also shared in CARE."
				content={content}
				hasCancel={!smaller}
				closeHandler={closeHandler}
				dlgClasses={{paper: classes.dlgPaper}}
				titleClassName={showSubtitle ? classes.dlgTitle : ""} />
		);
	}
}

CareAlertDialog.propTypes = {
	classes: PropTypes.object.isRequired,
	closeHandler: PropTypes.func.isRequired,
	nextStepHandler: PropTypes.func,
	activityId: PropTypes.number.isRequired,
	careStatusHandler: PropTypes.func.isRequired,
	open: PropTypes.bool,
	rating: PropTypes.object,
	width: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
	showSubtitle: PropTypes.bool
};

export default withStyles(styles)(withWidth()(CareAlertDialog));
